type DealerAppPath = "/:dealershipId/:locale/*"
const path: DealerAppPath = "/:dealershipId/:locale/*"

export const dealerAppRoute = {
	path,
	url: (dealershipId: string, locale?: string) => (locale ? `/${dealershipId}/${locale}` : `/${dealershipId}`),
}

export const getDealerAppRoute = (dealershipId: string, locale: string) =>
	`${window.location.origin}${dealerAppRoute.url(dealershipId, locale)}`
